import { GetNotificationsMetricsInDto, GetNotificationsMetricsOutDto } from '../../../types/notification.dto'

export const GET_NOTIFICATIONS_METRICS = 'GET_NOTIFICATIONS_METRICS'
export const GET_NOTIFICATIONS_METRICS_SUCCESS = 'GET_NOTIFICATIONS_METRICS_SUCCESS'
export const GET_NOTIFICATIONS_METRICS_ERROR = 'GET_NOTIFICATIONS_METRICS_ERROR'
export const RESET_GET_NOTIFICATIONS_METRICS = 'RESET_GET_NOTIFICATIONS_METRICS'

export interface GetNotificationsMetrics {
  type: typeof GET_NOTIFICATIONS_METRICS
  payload: GetNotificationsMetricsOutDto
}

export interface GetNotificationsMetricsSuccess {
  type: typeof GET_NOTIFICATIONS_METRICS_SUCCESS
  payload: GetNotificationsMetricsInDto
}

export interface GetNotificationsMetricsError {
  type: typeof GET_NOTIFICATIONS_METRICS_ERROR
  payload: string | boolean
}

export interface ResetGetNotificationsMetrics {
  type: typeof RESET_GET_NOTIFICATIONS_METRICS
  payload: null
}

export interface State {
  data: GetNotificationsMetricsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetNotificationsMetrics | GetNotificationsMetricsSuccess | GetNotificationsMetricsError | ResetGetNotificationsMetrics
